import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import FormModalContainer from '../../../../components/Modals/FormModalContainer'
import OfoqThemeBtn from '../../../../components/Buttons/OfoqThemeBtn'
import VectorsIcon from '../../../../images/vectors.svg'
import UseTranslation from '../../../../hooks/UseTranslation'

const CreationUsersEmptyBatchModal = ({ modalState, setModalState }) => {
  const { t } = UseTranslation()

  const handelClose = () => {
    setModalState(false)
  }
  return (
    <FormModalContainer
        modalState={modalState}
        handleClose={handelClose}
        modalTitle={t?.['Users Batch Creation']}
      >
        <Box component='img' src={VectorsIcon} sx={styles.image} />

        <Typography sx={styles.mainMsg}>
          {t?.['It Looks like all Employees having Email addresses in your Company already have users.']}
        </Typography>
        <Typography sx={styles.subMsg}>
          {t?.['Please Check your employees and users lists and try again.']}
        </Typography>

        <Box sx={styles.buttonsContainer}>
          <OfoqThemeBtn name={t?.Finish} onClick={handelClose}
          customStyle={styles.saveBtn}
          />
        </Box>
      </FormModalContainer>
  )
}
const styles = {
  image: { display: 'block', mx: 'auto', mt: '45px' },
  mainMsg: { mt: '36px', mb: '10px', fontSize: '16px', fontWeight: '400' },
  subMsg: { fontSize: '14px', color: '#92929D', textAlign: { xs: 'left', sm: 'center' } },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: 'solid 1px #e3e4ed',
    marginTop: { xs: '10px', sm: '40px' },
    padding: '10px 0px',
    marginRight: { xs: '0px', sm: '0px' },
  },
  saveBtn: {
    minWidth: { xs: '100%', sm: 'initial' },
    minHeight: '40px',
    fontSize: '14px',
    mx: { xs: 'auto', sm: '0px' },
    marginRight: { xs: '0px !important', sm: '20px !important' },
  },

}

export default CreationUsersEmptyBatchModal
